export const POPULARITY_STYLES = {
  "Most Visited": { color: "#1e40af", bg: "#dbeafe" },   // blue
  "Top Pick":     { color: "#065f46", bg: "#d1fae5" },   // green
  "Trending":     { color: "#92400e", bg: "#fef3c7" },   // amber
  "Best Deal":    { color: "#6d28d9", bg: "#ede9fe" },   // purple
  "Most Loved":   { color: "#9f1239", bg: "#ffe4e6" },   // rose
};